import React, {
    Component,
    createRef,
} from 'react'
import levenshtein from 'fast-levenshtein'
import SportBadges from './sport-badges/sport-badges'
import SelectionBox from './selection-box'
import classnames from 'classnames'
import { i18n } from '../../../../validator'
import InputGroup from '../../../../front/components/shared/sn-input-group'

@i18n()
export default class SportSelection extends Component {
    state = {
        filteredSports: this.props.sports,
        showSelectionBlock: false,
        inputValue: '',
        showMoreSportBadges: false,
        selectedSports: this.props.selectedSports || [],
    }

    constructor(props) {
        super(props)

        this.inputRef = createRef()
    }

    componentDidMount() {
        const { preselectedSport } = this.props

        if (preselectedSport) {
            this.onSportSelect(preselectedSport)
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ selectedSports: nextProps.selectedSports })
    }

    searchInputChanged = inputValue => {
        this.setState({ inputValue: inputValue }, () => this.filterSports())
    }

    toggleSelectionBox = event => {
        const { showSelectionBlock } = this.state

        if (event.target !== this.inputRef.current) {
            this.setState({ showSelectionBlock: false })
        } else {
            if (!showSelectionBlock) {
                this.setState({ showSelectionBlock: true })
            }
        }
    }

    filterSports = () => {
        const { sports } = this.props

        const { inputValue } = this.state
        const typed = inputValue.toLowerCase()

        const filtered = sports.filter(sport => (sport.label || sport.name) && (sport.label || sport.name).toLowerCase().indexOf(typed) !== -1)
        const levenshteined = sports.filter(sport => (sport.label || sport.name) && levenshtein.get(typed, (sport.label || sport.name).toLowerCase()) <= 3)

        this.setState({
            filteredSports: [...filtered, ...levenshteined].filter((el, i, a) => i === a.indexOf(el)),
        })

    }

    onSportSelect = selectedSport => {
        const {
            selectedSports,
            sports,
        } = this.props

        const indexOfSportInSelected = selectedSports?.findIndex(sport => (sport.value || sport.id) === (selectedSport.value || selectedSport.id))

        if (indexOfSportInSelected === -1) {
            const updatedSelectedSports = [...selectedSports, selectedSport]
            this.props.updateSelectedSports(updatedSelectedSports)

            this.setState({
                selectedSports:  updatedSelectedSports.map(selectedSportFromUpdated => sports.find(sport => (selectedSportFromUpdated.value || selectedSportFromUpdated.id) === (sport.value || sport.id))),
            })
        }

        this.setState({ showSelectionBlock: false })

        this.searchInputChanged('')
    }

    onSportDiselect = diselectedSport => {
        let { selectedSports } = this.props
        const { sports } = this.props

        const indexOfSportInSelected = selectedSports.findIndex(sport => (sport.value || sport.id) === (diselectedSport.value || diselectedSport.id))

        if (indexOfSportInSelected !== -1) {
            selectedSports.splice(indexOfSportInSelected, 1)
            this.props.updateSelectedSports(selectedSports)

            this.setState({
                selectedSports: selectedSports.map(selectedSport => sports.find(sport => (selectedSport.value || selectedSport.id) === (sport.value || sport.id))),
            })
        }
    }

    render() {
        const {
            inputValue,
            showSelectionBlock,
            selectedSports,
        } = this.state

        const {
            addSportHandle,
            singleSport,
            centered,
            hideAddSport,
            inputContainerClassName,
            t,
            disabled,
            inputPlaceholder,
        } = this.props

        return (
            <div className={classnames({
                'w-100': true,
                'd-flex flex-column': centered,
                'align-items-center': centered && !hideAddSport,
            })}>
                <div className={classnames({
                    'd-flex flex-column flex-wrap': true,
                    'align-self-center': centered && hideAddSport,
                })}>
                    {selectedSports?.length > 0 &&
                        <SportBadges
                            sports={selectedSports}
                            clicked={this.onSportDiselect}
                            noDelete={disabled}
                        />
                    }
                </div>
                <div className="d-flex align-items-center flex-wrap">
                    <div className={classnames({
                        'Filters__base-content__sport col-12 p-0': true,
                        'col-md-6': !centered,
                        [inputContainerClassName]: inputContainerClassName,
                    })}>
                        <InputGroup
                            className={classnames({
                                'd-none': selectedSports?.length > 0 && singleSport,
                            })}
                        >
                            <InputGroup.Input
                                type="text"
                                placeholder={inputPlaceholder || t('onBoardingSportInputPlaceholder')}
                                value={inputValue}
                                onChange={e => this.searchInputChanged(e.target.value)}
                                onFocus={this.toggleSelectionBox}
                                inputRef={this.inputRef}
                                disabled={!!disabled}
                            />
                            <InputGroup.Addon
                                position="append"
                                containerClassName="cursor-pointer"
                                textClassName="border-color-brand bg-color-brand text-color-white"
                                onClick={() => this.inputRef.current.focus()}
                            >
                                <i className="fa fa-search" />
                            </InputGroup.Addon>
                        </InputGroup>
                        {(showSelectionBlock && !disabled) &&
                            <SelectionBox
                                {...this.state}
                                {...this.props}
                                addSportHandle={addSportHandle}
                                onSportSelect={this.onSportSelect}
                                showSelectionBlock={this.state.showSelectionBlock}
                                toggleSelectionBox={this.toggleSelectionBox}
                            />
                        }
                    </div>
                    {!hideAddSport &&
                        <div className={classnames({
                            'col-12 p-0 font-size-sm mt-3': true,
                            'col-md-6 pl-md-3': !centered,
                        })}>
                            {t('sportNotFoundAddOne')}
                            <span
                                className="font-size-sm text-underline ml-2 cursor-pointer"
                                onClick={addSportHandle}
                            >
                                {t('createNewSport')}
                            </span>
                        </div>
                    }
                </div>
            </div>
        )
    }
}
